import React from "react";
import s from "../../MyOrders/MyOrdersCardMobile/MyOrdersCardMobile.module.css";

const ProductPrice = () => {
	return <div className={s.price}>600 грн.</div>;
};

export default ProductPrice;
